/** Быстрый вход в основные рабочие разделы планировщика с главной страницы. */
import { Link } from "react-router-dom";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";

const WORKSPACES = [
	{
		title: "План",
		description: "Начните чертить стены и расставлять предметы.",
		to: routerPaths.editor2d,
		Icon: UIKit.IconView2D,
	},
	{
		title: "Смета",
		description: "Проверьте объёмы работ и материалов по чертежу.",
		to: routerPaths.editorEstimate,
		Icon: UIKit.IconEstimate,
	},
	{
		title: "Мебель",
		description: "Соберите модуль, шкаф или кухню под нужный размер.",
		to: routerPaths.furnitureGenerator,
		Icon: UIKit.IconFurniture,
	},
];

export const WorkspaceSection = () => (
	<section aria-labelledby="lp-workspaces-title" className="border-y border-border bg-bg">
		<div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-20">
			<div className="flex flex-wrap items-end justify-between gap-4">
				<div>
					<UIKit.Text as="span" className="lp-mono block text-xs text-muted">
						Рабочие разделы
					</UIKit.Text>
					<h2 id="lp-workspaces-title" className="lp-display mt-3 text-3xl sm:text-4xl">
						Продолжить работу
					</h2>
				</div>
				<UIKit.Text className="max-w-110 text-sm leading-copy-relaxed text-muted">
					Откройте нужный инструмент сразу, без лишних переходов.
				</UIKit.Text>
			</div>
			<ul className="mt-8 grid gap-3 md:grid-cols-3">
				{WORKSPACES.map(({ title, description, to, Icon }) => (
					<li key={to}>
						<Link
							to={to}
							className="group flex min-h-34 items-start gap-4 border border-border bg-surface p-5 transition-colors hover:border-accent hover:bg-accent-soft"
						>
							<div className="flex size-10 shrink-0 items-center justify-center bg-accent-soft text-accent transition-colors group-hover:bg-accent group-hover:text-ink">
								<Icon className="size-5" />
							</div>
							<div>
								<UIKit.Text className="text-base font-semibold text-ink">{title}</UIKit.Text>
								<UIKit.Text className="mt-1 text-sm leading-copy text-muted">
									{description}
								</UIKit.Text>
							</div>
						</Link>
					</li>
				))}
			</ul>
			<nav
				aria-label="Подробнее об инструментах"
				className="mt-6 flex flex-wrap gap-x-6 gap-y-3 text-sm font-semibold text-accent"
			>
				<Link to={routerPaths.floorPlanLanding} className="underline underline-offset-4">
					Планировка квартиры
				</Link>
				<Link to={routerPaths.kitchenLanding} className="underline underline-offset-4">
					Конструктор кухни
				</Link>
				<Link to={routerPaths.roomLanding} className="underline underline-offset-4">
					Планировка комнаты
				</Link>
				<Link to={routerPaths.interior3dLanding} className="underline underline-offset-4">
					3D-планировка
				</Link>
				<Link to={routerPaths.wardrobeLanding} className="underline underline-offset-4">
					Конструктор шкафа
				</Link>
				<Link to={routerPaths.elevationsLanding} className="underline underline-offset-4">
					Развёртки стен
				</Link>
				<Link to={routerPaths.estimateLanding} className="underline underline-offset-4">
					Смета ремонта
				</Link>
			</nav>
		</div>
	</section>
);
